<template>
    <div id="app">
        <backend-header v-if="showHeader"></backend-header>
        <div id="wrapper" class="app-sidebar-right">
            <backend-sidebar v-if="showHeader"></backend-sidebar>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    require("@babel/polyfill");
    import HelloWorld from './components/HelloWorld.vue';
    import BackendHeader from '@/components/backend/partials/header';
    import BackendFooter from '@/components/backend/partials/footer';
    import BackendSidebar from '@/components/backend/partials/sidebar';

    export default {
        name: 'app',
        components: {
            'backend-header': BackendHeader,
            'backend-footer': BackendFooter,
            'backend-sidebar': BackendSidebar,

        },
        data: () => ({
            showHeader:true,
        }),
        mounted: function() {

            var self = this;

            if(window.location.pathname == "/login") {
                self.showHeader = false;
                $(".app-sidebar-right").css("padding-left","0px");
                $(".app-sidebar-right").css("margin-top","0px");
                $(".app-sidebar-right").css({"-webkit-transition":"all 0.0s ease","-moz-transition":"all 0.0s ease","-o-transition":"all 0.0s ease","transition":"all 0.0s ease"});
            } else {
                self.showHeader = true;
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/App.vue